import React, {useEffect, useState} from 'react'
import {DashboardParkService} from '../../../services/DashboardParkService'
import Notify from '../../../services/Notify'
import {DashboardStackedBar} from '../../../component/Dashboard/DashboardStackedBar'
import Loading from '../../../component/Loading/Loading'
import {Col, Row} from 'react-bootstrap'

export function DashboardPage({bizLocationId, dateFilter}) {

  const [page, setPage] = useState(0);
  const [dashboardFormatedData, setDashboardFormatedData] = useState(null)
  const [rowsName, setRowsName] = useState(null)
  const [isLoading, setIsLoading] = useState(false);

  const getDashboardData = async () => {
    try {
      setIsLoading(true);
      const data = await DashboardParkService.getDashboardData(bizLocationId, dateFilter, page);
      formatDataToDashboard(data.content)
      getRowsName(data.content);
    } catch (error) {
      Notify.error('Erro ao buscar dados', error)
    } finally {
      setIsLoading(false);
    }
  }

  const formatDataToDashboard = (dashboardData) => {

    const statusByColor = {
      'purple': {name: '>130%', data: []},
      'blue': {name: '>120%', data: []},
      'green': {name: '100%', data: []},
      'yellow': {name: '<90%', data: []},
      'orange': {name: '<80%', data: []},
      'red': {name: '<65%', data: []}
    };

    const getDataByColor = (color, x) => {
      const data = x.filter(t => t.color === color);
      if (data.length > 0) {
        return (data[0].quantity * 100).toFixed(2);
      }
      return 0;
    }

    dashboardData.forEach(item => {
      Object.keys(statusByColor).forEach(color => {
        const statusByColorItem = statusByColor[color];
        statusByColorItem.data.push(getDataByColor(color, item.colorQuantity));
      });

      console.log('statusByColor', statusByColor);

      setDashboardFormatedData(Object.keys(statusByColor).map(x => statusByColor[x]).reverse());
    });
  }

  const getRowsName = (dashboardData) => {
    setRowsName(dashboardData.map(x => {
      return x.friendlyName
    }))
  }

  useEffect(() => {
    setDashboardFormatedData();
    setRowsName();
    getDashboardData();
  }, [page, bizLocationId, dateFilter])

  if (isLoading) {
    return <Loading/>
  }

  return dashboardFormatedData && rowsName ?
      <DashboardStackedBar
          data={dashboardFormatedData}
          lineNames={rowsName}/> :
      <Row className="d-flex w-100 justify-content-center align-items-center mt-5">
        <Col>
          <p className="text-dark h3">Sem dados</p>
        </Col>
      </Row>
}



// WEBPACK FOOTER //
// ./src/pages/StockLevel/Dashboard/DashboardPage.js